module.exports = __webpack_public_path__ + "static/img/Y.6a14f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/Y.png
// module id = UTu6
// module chunks = 0